export default __webpack_public_path__ + "static/media/flop-equity-rangevsrange_0052_thumb.10a081a7.jpg";